import React from 'react'

import MetricAbout from 'components_new/organisms/MetricAbout'
import MetricNavigation from 'components_new/organisms/MetricNavigation'

import PageLayout, {
  PageLayoutProps
} from 'components_new/templates/PageLayout'

import { useParams } from 'utils/hooks'
import { useMetric } from 'redux/hooks/Metrics'
import { BreadcrumbsProps } from 'components_new/molecules/Breadcrumbs'
import { useTranslation } from 'language/translator'

const MetricTemplate = (props: PageLayoutProps) => {
  const { children, ...rest } = props

  const { id } = useParams()
  const metric = useMetric(id, null)
  const { lang, t } = useTranslation()

  const breadcrumbs: BreadcrumbsProps['items'] = [
    {
      href: '/metrics',
      icon: { name: 'Metrics' },
      title: t('metrics', 'metric')
    }
  ]

  if (metric) {
    breadcrumbs.push({
      href: `/metrics/${metric.id}`,
      icon: { name: 'Metric' },
      title: metric.title[lang],
      titleIcon: metric.access.private ? { name: 'Private' } : undefined
    })
  }

  return (
    <PageLayout
      rightSidebar={{
        content: (
          <>
            <MetricNavigation id={id} sx={{ mb: 2 }} />
            <MetricAbout />
          </>
        ),
        size: 'medium'
      }}
      topbar={{
        breadcrumbs: breadcrumbs,
        mobile: {
          goBack: true
        }
      }}
      {...rest}
    >
      {children}
    </PageLayout>
  )
}

export default MetricTemplate
